import { FC, PropsWithChildren } from 'react';
import { StyledLosenge } from './Losenge.styles';

export interface LosengeProps extends PropsWithChildren {
  status: 'success' | 'error' | 'warning' | 'info';
  style?: React.CSSProperties;
  title?: string;
  handleClick?: () => void;
  disabled?: boolean;
}

/**
A simple stylised status indicator component
*/
export const Losenge: FC<LosengeProps> = ({
  children,
  status,
  disabled,
  style,
  handleClick,
  ...otherProps
}) => {
  return (
    <StyledLosenge
      onClick={handleClick}
      style={style || {}}
      $status={status}
      $disabled={disabled}
      {...otherProps}
    >
      {children}
    </StyledLosenge>
  );
};

export default Losenge;
